import { render } from "./Portfolios.vue?vue&type=template&id=aadd9a4e"
import script from "./Portfolios.vue?vue&type=script&lang=js"
export * from "./Portfolios.vue?vue&type=script&lang=js"

import "./Portfolios.vue?vue&type=style&index=0&id=aadd9a4e&lang=css"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__